module.exports = __webpack_public_path__ + "d1a2f2f8cf145e7afdb49c6e07f47144.jpg";